import { motion } from 'framer-motion';

const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className = '' }) => (
    <motion.div
        initial={{ opacity: 0, y: 48 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-60px' }}
        transition={{ duration: 1, delay, ease: EASE }}
        className={className}
    >
        {children}
    </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = '' }) => (
    <span className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
            className={`block ${className}`}
            initial={{ y: '115%' }}
            animate={{ y: 0 }}
            transition={{ duration: 1.15, delay, ease: EASE }}
        >
            {children}
        </motion.span>
    </span>
);

export const PageHeader = ({ kicker, title, sub }) => (
    <header className="px-6 md:px-12 pt-40 pb-16 md:pt-48 md:pb-24 max-w-[1600px] mx-auto">
        <FadeUp>
            <p className="text-xs md:text-sm tracking-[0.35em] uppercase text-dusk mb-6" data-testid="page-kicker">{kicker}</p>
        </FadeUp>
        <FadeUp delay={0.1}>
            <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl tracking-tighter text-paper" data-testid="page-title">{title}</h1>
        </FadeUp>
        {sub && (
            <FadeUp delay={0.2}>
                <p className="mt-6 text-base md:text-lg text-fog max-w-xl" data-testid="page-subtitle">{sub}</p>
            </FadeUp>
        )}
    </header>
);
